import { useRequiredContext } from "@redotech/react-util/context";
import SaleIcon from "@redotech/redo-icons/sale-03.svg";
import SaleFilledIcon from "@redotech/redo-icons/sale-03_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

export const DiscountRulesItems = memo(function DiscountRulesItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const href = routes.getConversionSubRoute("discount-rules");
  const match = useMatch({ path: href, end: false });
  const { locked, onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.NAV_DISCOUNT_RULES,
  );

  return (
    <RedoSecondaryNavItem
      action={
        locked
          ? { type: "button", onClick: onLockedClick }
          : { type: "link", href }
      }
      dimmed={locked}
      FilledIcon={SaleFilledIcon}
      friendlyName="Discount rules"
      id="discount-rules"
      isPrivate={locked}
      selected={locked ? false : !!match}
      UnfilledIcon={SaleIcon}
    />
  );
});
